import React from 'react';
import { call, put, takeLatest } from 'redux-saga/effects';

import { captureException } from '../../../client/sentry';
import { graphql } from '../../../globals/api/requests';
import { promptToast } from '../../../components/toast-container/actions';
import actions, {
  REMOVE_LIST_REQUEST,
  RESTORE_LIST_REQUEST,
} from '../actions/lists';
import Undo from '../undo';

export function* removeList({ id }) {
  try {
    const response = yield call(
      graphql,
      `mutation listDelete($id: Int!) {
        listDelete(id: $id) {
          restoreToken
        }
      }`,
      {
        id,
      }
    );

    if (response.errors) {
      yield put(actions.removeListError(response.errors[0]));
      return;
    }

    const { restoreToken } = response.data.listDelete;

    yield put(actions.removeListSuccess(restoreToken, id));

    yield put(
      promptToast(
        'success',
        <React.Fragment>
          {window.APP_GLOBALS.t('lists', 'confirm.list-deleted')}
          <Undo undo={actions.restoreListRequest(id, restoreToken)} />
        </React.Fragment>
      )
    );
  } catch (err) {
    yield call(captureException, err);
    yield put(actions.removeListError(err));
  }
}

export function* restoreList({ restoreToken, id }) {
  try {
    const response = yield call(
      graphql,
      `mutation restoreItem($token: String!) {
        restoreItem(token: $token) {
          success
        }
      }`,
      {
        token: restoreToken,
      }
    );

    if (response.errors) {
      yield put(actions.restoreListError(response.errors[0]));
      return;
    }

    yield put(actions.restoreListSuccess(id, restoreToken));

    yield put(
      promptToast(
        'success',
        window.APP_GLOBALS.t('lists', 'confirm.list-restored')
      )
    );
  } catch (err) {
    yield call(captureException, err);
    yield put(actions.restoreListError(err));
  }
}

function* mySaga() {
  yield takeLatest(REMOVE_LIST_REQUEST, removeList);
  yield takeLatest(RESTORE_LIST_REQUEST, restoreList);
}

export default mySaga;
